import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TooltipModule } from '@intranet/components/tooltip/tooltip.module';
import { SharedModule } from '@intranet/shared/shared.module';

import { UserService } from '@intranet/modules/users';
import { LoginService } from '@intranet/modules/login';

import { HeaderComponent } from './header.component';
import { TimerHeaderComponent } from './timer-header/timer-header.component';
import { MatDialogModule } from '@angular/material/dialog';
import { InfoModalComponent } from '../../modules/info/info-modal.component';
import { InfoButtonComponent } from '../../modules/info/info-button.component';
import { DialogModule } from '../dialog/dialog.module';
import { OverlayModule } from '@angular/cdk/overlay';
import { TogglTimerButtonModule }     from '@intranet/modules/toggl/toggl-timer-button/toggl-timer-button.module';
import { ReactiveFormsModule }   from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        TooltipModule,
        DialogModule,
        OverlayModule,
        RouterModule,
        SharedModule,
        TogglTimerButtonModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatMenuModule,
        MatProgressSpinnerModule,
    ],
    exports: [HeaderComponent, TimerHeaderComponent],
    declarations: [
        HeaderComponent,
        TimerHeaderComponent,
        InfoModalComponent,
        InfoButtonComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderModule {}
